import { render, staticRenderFns } from "./IncidentNumber.vue?vue&type=template&id=316271c2&"
import script from "./IncidentNumber.vue?vue&type=script&lang=js&"
export * from "./IncidentNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports